import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          strokeWidth={1}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="fj-icons-bg-color"
          d="M.5.5h40v28.21H.5z"
        />
        <path fill="fj-icons-primary-color" d="M17.5 28.84h6v11.67h-6z" />
        <path
          fill="fj-icons-bg-color"
          strokeWidth={1}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9.67 40.5h21.66"
        />
        <path
          fill="fj-icons-primary-color"
          d="M33.52 25.19h-4.5V6.44h4.5zM26.05 25.19h-4.5V8.78h4.5zM18.58 25.19h-4.5V11.13h4.5zM11.11 25.19h-4.5V13.47h4.5z"
        />
        <path
          fill="none"
          strokeWidth={0.5}
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.02 5.04v20.15h30"
        />
      </g>
    </g>
  </svg>
);

const Reports = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Reports;
